let guestDraftCounter = 0;

export const createGuestDraft = () => ({
  id: null,
  localId: `new-${++guestDraftCounter}`,
  name: "",
  slug: "",
  mobile: "",
  table: "",
  confirmed: false,
  wards: [],
});

export const createWardDraft = () => ({
  id: null,
  name: "",
  table: "",
  confirmed: false,
});

export const slugify = (value) =>
  (value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

export const getSafeBaseSlug = (value) => {
  const slug = slugify(value || "");
  if (slug.length >= 3) {
    return slug;
  }
  if (slug.length > 0) {
    return `invitado-${slug}`;
  }
  return "invitado";
};

export const ensureUniqueSlug = (requestedSlug, usedSlugs) => {
  const base = getSafeBaseSlug(requestedSlug);
  if (!usedSlugs.has(base)) {
    usedSlugs.add(base);
    return base;
  }

  let index = 2;
  let candidate = `${base}-${index}`;
  while (usedSlugs.has(candidate)) {
    index += 1;
    candidate = `${base}-${index}`;
  }

  usedSlugs.add(candidate);
  return candidate;
};

export const getSlugSeedFromGuest = (guest) => {
  const manualSlug = slugify(guest?.slug || "");
  const nameSlug = slugify(guest?.name || "");

  // Avoid preserving auto-generated short slugs such as "invitado-f"
  // when a better slug can be built from the guest name.
  if (/^invitado-[a-z0-9]$/.test(manualSlug) && nameSlug.length >= 3) {
    return nameSlug;
  }

  if (manualSlug.length >= 3) {
    return manualSlug;
  }

  if (nameSlug.length >= 1) {
    return nameSlug;
  }

  return "invitado";
};

export const buildUniqueSlugsFromGuests = (guests) => {
  const used = new Set();
  return guests.map((guest) => ensureUniqueSlug(getSlugSeedFromGuest(guest), used));
};

export const normalizeWards = (wards = []) =>
  wards.map((ward, index) => ({
    id: index + 1,
    name: (ward.name || "").trim(),
    table: (ward.table || "").trim(),
    confirmed: ward.confirmed === true,
  }));

export const getFirestoreErrorMessage = (error) => {
  const code = error?.code || "unknown";
  const rawMessage = error?.message || "Error desconocido";

  if (code === "permission-denied") {
    return "Firestore rechazó la operación por reglas (permission-denied). Revisa reglas/publicación del proyecto.";
  }
  if (code === "failed-precondition") {
    return "Firestore no está listo en ese proyecto (failed-precondition). Verifica que la base de datos exista y esté habilitada.";
  }
  if (code === "unavailable") {
    return "Firestore no está disponible temporalmente (unavailable). Revisa conexión de red.";
  }

  return `Firestore error (${code}): ${rawMessage}`;
};

export const formatInvitationLabel = (invitation) =>
  `${invitation.familyAlias || "Sin alias"} (${invitation.id})`;
